import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectedTicketsTableModule } from '../selected-tickets-table/selected-tickets-table.module';

@Component({
  selector: 'fgbcl-ticket-transfer-confirm-modal',
  standalone: true,
  imports: [FGBSharedModule, CommonModule, SelectedTicketsTableModule],
  templateUrl: './ticket-transfer-confirm-modal.component.html',
  styleUrl: './ticket-transfer-confirm-modal.component.scss'
})
export class TicketTransferConfirmModalComponent {
  @Input() emailAddress: string;

  constructor(private modal: NgbActiveModal) {
  }

  close(): void{
    this.modal.close();
  }

  confirm(): void{
    this.modal.close(true);
  }
}
